/**
 * @file: SupplierPc.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-入库管理
 */
import request from '@/utils/request'

/**
 * 添加、更新供应商(qiuyanping)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcSupplierAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/add',
    method: 'post',
    data
  })
}

/**
 * 根据供应商名称模糊匹配供应商信息(qiuyanping)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcSupplierList(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/SupplierPc.js